import { Link } from 'wouter';
import { ArrowLeft } from 'lucide-react';

export function PrivacyScreen() {
  return (
    <div className="flex-1 flex flex-col items-center px-6 py-8">
      <div className="w-full max-w-2xl">
        <Link
          href="/"
          className="inline-flex items-center gap-1.5 text-sm text-parchment-400 dark:text-white/50 hover:text-parchment-text/80 dark:hover:text-white/70 transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to heal.fm
        </Link>

        <h1 className="font-serif text-3xl text-parchment-text dark:text-white/90 mb-2">
          Privacy Policy
        </h1>
        <p className="text-sm text-parchment-400 dark:text-white/40 mb-10">
          Effective February 3, 2026
        </p>

        <div className="space-y-8 text-parchment-text/80 dark:text-white/70 leading-relaxed">
          <section>
            <h2 className="font-serif text-xl text-parchment-text dark:text-white/90 mb-3">
              What heal.fm Does
            </h2>
            <p>
              heal.fm generates personalized music playlists designed to accompany
              ketamine-assisted therapy sessions. The app curates tracks that align
              with the therapeutic arc of different treatment types, including IV, IM,
              oral, and Spravato (esketamine) sessions.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-parchment-text dark:text-white/90 mb-3">
              Apple Music Integration
            </h2>
            <p>
              heal.fm integrates with Apple Music to provide full-length track playback
              and playlist saving. When you connect your Apple Music account, the app
              accesses the Apple Music catalog to search for and play tracks. If you
              choose to save a playlist, it is written to your Apple Music library.
              heal.fm does not read or access your existing library content.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-parchment-text dark:text-white/90 mb-3">
              Audio Playback
            </h2>
            <p>
              heal.fm plays audio through Apple Music (full tracks), 30-second preview
              clips (no account required), or YouTube embeds. Audio playback is
              streamed directly from these services and is not recorded or stored by
              heal.fm.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-parchment-text dark:text-white/90 mb-3">
              Data Collection &amp; Storage
            </h2>
            <p>
              heal.fm stores your preferences (treatment type, session duration, theme,
              and visual effect settings) in your browser's local storage. This data
              never leaves your device and is not transmitted to any server. No
              personal information, account data, or usage history is collected or
              stored server-side.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-parchment-text dark:text-white/90 mb-3">
              Analytics &amp; Tracking
            </h2>
            <p>
              heal.fm optionally uses PostHog to collect anonymous, aggregate usage
              events (e.g., session start, playback actions). PostHog is only enabled
              when a PostHog key is configured; otherwise no analytics events are sent.
              Analytics requests are proxied through <span className="font-mono">/p</span>.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-parchment-text dark:text-white/90 mb-3">
              Affiliate Links
            </h2>
            <p>
              Some accessory links are Amazon affiliate links. If you click an
              affiliate link, Amazon may set cookies and receive standard referral
              information. heal.fm does not receive your personal data from Amazon.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-parchment-text dark:text-white/90 mb-3">
              Third-Party Data Sharing
            </h2>
            <p>
              heal.fm does not sell, share, or transfer your personal data to any third
              party. The app communicates with Apple Music and YouTube for audio
              playback, PostHog for optional analytics, and Amazon when you click
              affiliate links.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-parchment-text dark:text-white/90 mb-3">
              Contact
            </h2>
            <p>
              If you have questions about this privacy policy or your data, contact us
              at{' '}
              <a
                href="mailto:hello@heal.fm"
                className="text-parchment-text dark:text-white/90 underline underline-offset-2 hover:text-parchment-text/60 dark:hover:text-white/60 transition-colors"
              >
                hello@heal.fm
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
